import { render, staticRenderFns } from "./accordion-room-bedrooms.vue?vue&type=template&id=f6ad1fb0"
import script from "./accordion-room-bedrooms.js?vue&type=script&lang=js&external"
export * from "./accordion-room-bedrooms.js?vue&type=script&lang=js&external"
import style0 from "./accordion-room-bedrooms.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports